import { render, staticRenderFns } from "./AdvisorDashboard.vue?vue&type=template&id=27a0b3a4&scoped=true"
import script from "./AdvisorDashboard.vue?vue&type=script&lang=js"
export * from "./AdvisorDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdvisorDashboard.vue?vue&type=style&index=0&id=27a0b3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0b3a4",
  null
  
)

export default component.exports